// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-layout{--v-scrollbar-offset:0px;display:flex;flex:1 1 auto}.v-layout--full-height{--v-scrollbar-offset:inherit;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
